export enum OrderNumeration {
    Company = "company",
    Office = "office",
}
